import { toMM100GetQuote } from '@/components/PowerKitPreSale/components/PreOrder/InfoQuote/utils';
import Image from '@/components/UI/Image';
import EFAlarmClockIcon from '@/components/UI/svg/Icons/EFAlarmClockIcon';
import EFAskMeIcon from '@/components/UI/svg/Icons/EFAskMeIcon';
import EFAvatorIcon from '@/components/UI/svg/Icons/EFAvatorIcon';
import EFRightArrow from '@/components/UI/svg/Icons/EFRightArrow';
import FacebookSvgPc from '@/components/UI/svg/Icons/FacebookSvgPc';
import LinkSvgPc from '@/components/UI/svg/Icons/LinkSvgPc';
import OutlookSvgPc from '@/components/UI/svg/Icons/OutlookSvgPc';
import TwitterSvgPc from '@/components/UI/svg/Icons/TwitterSvgPc';
import { actIdGetAccessFlow, actIdUpdateAccessFlow } from '@/service/crowdfunding';
import { getWSSUrl } from '@/utils/countryRegion';
import wss from '@/utils/mqtt-client-powerkit';
import topics from '@/utils/mqtt-client-powerkit/crowd-funding-topics';
import { useGlobal } from '@/utils/useGlobal';
import { Button, message, Tooltip } from 'antd';
import { EmailShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';
import SwiperCore, { A11y, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { hideCountry } from '../..';
import { useStore } from '../../context';
import style from './index.module.scss';
import InfoCollection from './infocollection';
import SuccessDialog from './successDialog';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

//开始时间和截止时间
const dateObjS: any = {
    us: process.env.NEXT_PUBLIC_MM100_US_DEADLINE_START,
    jp: process.env.NEXT_PUBLIC_MM100_JP_DEADLINE_START,
    kr: process.env.NEXT_PUBLIC_MM100_KR_DEADLINE_START,
    au: process.env.NEXT_PUBLIC_MM100_AU_DEADLINE_START,
};
const dateObjE: any = {
    us: process.env.NEXT_PUBLIC_MM100_US_DEADLINE_END,
    jp: process.env.NEXT_PUBLIC_MM100_JP_DEADLINE_END,
    kr: process.env.NEXT_PUBLIC_MM100_KR_DEADLINE_END,
    au: process.env.NEXT_PUBLIC_MM100_AU_DEADLINE_END,
};
function getDateObjS(locale: string) {
    return dateObjS[locale] || dateObjS['us'];
}
function getDateObjE(locale: string) {
    return dateObjE[locale] || dateObjE['us'];
}
const noStartLocaleArr: any = [];
const oneDayTimes = 1000 * 60 * 60 * 24;
//开始时间和截止时间--end

function formatFlow(val: string) {
    return (val || '0').toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}

export default function PreOrder({ activityId, preCallback }: any) {
    const { useState, useRouter, gtm, useEffect, useLang } = useGlobal();
    const presaleState = useStore();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const swiperImgs: any = {
        us: [
            `/img/mm100/preview/powerkits-banner1.jpg`,
            '/img/mm100/preview/powerkits-banner2.jpg',
            '/img/mm100/preview/powerkits-banner3.jpg',
            locale === 'cn' ? '/img/mm100/preview/powerkits-banner4_cn.jpg' : '/img/mm100/preview/powerkits-banner4.jpg',
            '/img/mm100/preview/powerkits-banner5.jpg',
            locale === 'cn' ? '/img/mm100/preview/powerkits-banner6_cn.jpg' : '/img/mm100/preview/powerkits-banner6.jpg',
        ],
        au: [
            '/img/mm100/preview/powerkits-banner2.jpg',
            '/img/mm100/preview/powerkits-banner3.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1724911505002/powerkits-banner4_au.png',
            '/img/mm100/preview/powerkits-banner5.jpg',
            '/img/mm100/preview/powerkits-banner6.jpg',
        ],
    };

    let locationHref = '';
    if (typeof window !== 'undefined') {
        locationHref = location.href;
    }
    //访问量--------start
    const [totalFlows, setTotalFlows] = useState('--');

    // 访问量--同步比较值，如果最新值比旧值少，则不更新
    const updateTotalFlows = (oldData: string, newData: string) => {
        const oldFlow = parseInt(oldData, 10) || 0;
        const newFlow = parseInt(newData, 10) || 0;
        //  可能存在取之延时，当值比上一个值大时才设置
        if (newFlow > oldFlow) {
            setTotalFlows(newData);
        }
    };

    // 访问量--最新访问量
    const getFlowsTimer = () => {
        actIdGetAccessFlow({
            activityId: activityId,
        }).then((res: any) => {
            if (res?.code === '0') {
                updateTotalFlows(totalFlows, res.data.totalFlow);
            }
        });
    };

    useEffect(() => {
        if (!activityId) return;
        getFlowsTimer();
        actIdUpdateAccessFlow({
            activityId: activityId,
        });
    }, [activityId]);

    const url = String(getWSSUrl(locale));
    const subscribes = ['number'];
    const { receiver } = wss({
        url,
        topics,
        locale,
        subscribes,
        activityId,
    });

    useEffect(() => {
        const { data } = receiver;

        if (data) {
            updateTotalFlows(totalFlows, data.totalFlow);
        }
    }, [receiver]);
    //访问量--------end

    //设置结束时间--------start
    const deadlineStrA1 = String(getDateObjS(locale)).replace(/-/g, '/');
    const deadlineStrA2 = String(getDateObjE(locale)).replace(/-/g, '/');
    const deadlineA0 = new Date().getTime();
    const deadlineA1 = new Date(deadlineStrA1).getTime();
    const deadlineA2 = new Date(deadlineStrA2).getTime();
    const [endDay, setEndDay] = useState(0);

    const [isCollectInfo, setIsCollectInfo] = useState(false);

    // 是否展示评论成功弹窗
    const [isCommSuccVisible, setCommSuccVisible] = useState(false);

    // 中国站 二维码弹窗
    const [showDetailsModal_CN, setShowDetailsModal_CN] = useState(false);

    useEffect(() => {
        if (noStartLocaleArr.includes(locale)) {
            //未上线的mm100
            const days1 = Math.round((deadlineA1 - deadlineA0) / oneDayTimes);
            const days = Math.max(days1, 0);
            setEndDay(days);
        } else {
            //已上线的mm100
            const days1 = Math.round((deadlineA2 - deadlineA0) / oneDayTimes);
            const days = Math.max(days1, 0);
            setEndDay(days);
        }
    }, []);
    //设置结束时间--------end

    const preOrderNow = () => {
        if (locale === 'cn') {
            return setShowDetailsModal_CN(true);
        }
        if (['us', 'ca', 'de', 'fr', 'uk', 'jp', 'it', 'es'].includes(locale)) {
            window?.fbq && window?.fbq('track', 'Donate');
        }
        if (['au'].includes(locale)) {
            window?.fbq && window?.fbq('track', 'Contact');
        }
        switch (locale) {
            case 'us':
            case 'ca':
            // return window.open(
            //     `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/on-the-road-power-solution#RV-G`,
            //     '_blank',
            // );
            case 'eu':
            case 'uk':
            case 'de':
            case 'fr':
            case 'it':
            case 'es':
                toMM100GetQuote(locale);
                break;
            case 'au':
            case 'kr':
            case 'jp':
                setIsCollectInfo(true);
                break;
            default:
                preCallback?.('1');
        }
    };

    const preOrderNowAndGtm = () => {
        preOrderNow();
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_get_a_quote',
            product_name: 'EcoFlow Power Kits',
            position: 'introduction',
            option_name: 'none',
        });
    };

    const buyNow = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_pre_order',
            product_name: 'EcoFlow Power Kits',
        });
        if (locale === 'us') {
            // const { protocol, host } = window.location;
            // const href = `${protocol}//${host}`;
            // window.open(`${href}/${locale}/power-kits/recommend`);
            window.open('https://www.campervan-hq.com/products/ecoflow-power-kits-5kwh?variant=43873772208381');
        } else {
            preCallback?.('1');
        }
    };

    const carouselImgs = swiperImgs[locale] || swiperImgs['us'];

    const [isLinkVisible, setIsLinkVisible] = useState(false);

    const copyLink = () => {
        const url = window.location.href;
        if (navigator.clipboard && window.isSecureContext) {
            window.navigator.clipboard.writeText(url);
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'absolute';
            textArea.style.opacity = '0';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            new Promise(() => {
                const copyStatus = document.execCommand('copy');
                if (!copyStatus) {
                    message.error('The current browser does not support the automatic copy function, please manually copy in the address bar');
                }
                textArea.remove();
            });
        }
        setIsLinkVisible(true);
        setTimeout(() => {
            setIsLinkVisible(false);
        }, 2000);
    };

    const openCalculatorPage = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_help_me_choose',
            product_name: 'EcoFlow Power Kits',
        });
        window?.fbq && window?.fbq('track', 'CustomizeProduct');
        let calculatorUrl = `/${locale}/calculators/power-kits`;
        if (!location.origin) {
            // ie的一些老版本不兼容
            calculatorUrl = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}/${locale}/calculators/power-kits`;
        }
        // 增加name是为了防止点击打开多个calculator/mm100页面
        window.open(calculatorUrl, 'calculators_mm100');
    };

    const handleOpenChatBox = () => {
        const zE = (window as any).zE;
        if (!zE) return;
        zE('messenger:set', 'zIndex', 9999);
        zE('messenger', 'open');

        /** gtm 埋点 --start */
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_ask_me_everything',
            product_name: t('presale.productname'),
        });
        /** gtm 埋点 --end */
    };

    const collectInfoCb = ({ status }: any) => {
        if (status === 'success') {
            setIsCollectInfo(false);
            setCommSuccVisible(true);
        }
        switch (status) {
            case 'success':
                setIsCollectInfo(false);
                setCommSuccVisible(true);
                break;
            case 'close':
                setIsCollectInfo(false);
                break;
        }
    };

    useEffect(() => {
        if (presaleState.isQuoteVisible === true) {
            preOrderNow();
        }
    }, [presaleState]);

    const closeSuccDialog = () => {
        setCommSuccVisible(false);
    };

    return (
        <div className={style.preOrder}>
            {isCollectInfo && <InfoCollection activityId={activityId} cbFunc={collectInfoCb} />}
            {isCommSuccVisible && <SuccessDialog closeSuccDialog={closeSuccDialog} />}
            <div className="prd-list">
                <Swiper
                    modules={[Navigation, Pagination]}
                    width={680}
                    height={510}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    initialSlide={0}
                    loop={true}
                    lazy={true}
                    autoplay={false}
                    id="air-swiper"
                    speed={800}
                >
                    {carouselImgs.map((item: any, indx: number) => {
                        return (
                            <SwiperSlide key={indx}>
                                <div className="swiper-img">
                                    <Image
                                        src={item}
                                        className="fullImgs"
                                        layout="fill"
                                        alt={t('presale.productname')}
                                        aria-label={t('presale.productname')}
                                    ></Image>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
            <div className="prd-order">
                {!hideCountry.includes(locale) && <p className="subtit">{t('presale.preorder.title')}</p>}
                <h1 className="title">{t('presale.productname')}</h1>
                <p className="title-desc">{t('presale.preorder.productdesc')}</p>
                <div className="interest-visitor">
                    <div className="icon">
                        <EFAvatorIcon />
                    </div>
                    <div>
                        <p className="num">{formatFlow(totalFlows)}</p>
                        <p className="desc">{t('presale.preorder.intrestdesc')}</p>
                        {locale === 'au' && <p className="desc tips">{t('presale.preorder.tips')}</p>}
                    </div>
                </div>
                {!hideCountry.includes(locale) && (
                    <div className="end-time">
                        <div className="icon">
                            <EFAlarmClockIcon />
                        </div>
                        <div>
                            {locale === 'jp' || locale === 'kr' ? (
                                <div className="jp-end-days">
                                    <p className="desc">{t('presale.preorder.saveendin')}</p>
                                    <p>
                                        <span className="num">{endDay}</span>
                                        <span className="union">{t('presale.preorder.days')}</span>
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <p className="num">
                                        {endDay}
                                        <span className="union">{t('presale.preorder.days')}</span>
                                    </p>
                                    <p className="desc">{t('presale.preorder.saveendin')}</p>
                                </>
                            )}
                        </div>
                    </div>
                )}
                {['us', 'uk', 'ca', 'de', 'fr', 'eu', 'au', 'cn', 'za', 'it', 'es'].includes(locale) ? (
                    <div className="btns">
                        {locale !== 'cn' && (
                            <Button type="primary" className="order-btn" onClick={buyNow}>
                                {t('presale.bundles.buynow')}
                            </Button>
                        )}
                        {!['za', 'au'].includes(locale) && (
                            <Button className="help-choose" onClick={preOrderNowAndGtm}>
                                <div className="choose-box">
                                    {/* <div className="text">{['us', 'ca'].includes(locale) ? 'Find Installers' : t('presale.preorder.preordernow')}</div> */}
                                    <div className="text">{t('presale.preorder.preordernow')}</div>
                                </div>
                            </Button>
                        )}
                        {!['au'].includes(locale) && (
                            <Button className="help-choose" onClick={openCalculatorPage}>
                                <div className="choose-box">
                                    <div className="text">{t('presale.preorder.helpchoose')}</div>
                                    <EFRightArrow className="choose-svg" />
                                </div>
                            </Button>
                        )}
                    </div>
                ) : (
                    <div className="btns au-btns">
                        {locale === 'kr' && (
                            <Button type="primary" className="order-btn" onClick={preOrderNowAndGtm}>
                                {t('presale.preorder.preordernow')}
                            </Button>
                        )}

                        {/* {locale === 'jp' && (
                            <Button type="primary" className="order-btn" onClick={preOrderNowAndGtm}>
                                {t('presale.preorder.preordernow')}
                            </Button>
                        )} */}

                        {locale !== 'sa' && (
                            <Button className="help-choose" onClick={openCalculatorPage}>
                                <div className="choose-box">
                                    <div className="text">{t('presale.preorder.helpchoose')}</div>
                                    <EFRightArrow className="choose-svg" />
                                </div>
                            </Button>
                        )}

                        {[''].includes(locale) && (
                            <Button className="help-choose" onClick={handleOpenChatBox}>
                                <div className="choose-box">
                                    <div className="text">{t('presale.preorder.Ask_Me_Everything')}</div>
                                    <EFAskMeIcon className="choose-svg" />
                                </div>
                            </Button>
                        )}
                    </div>
                )}
                {locale !== 'cn' && (
                    <div className="share-btns">
                        <div className="btn-wrapper fb-icon">
                            <FacebookShareButton
                                url={locationHref}
                                onClick={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'share',
                                        method: 'Facebook',
                                        item_id: t('presale.productname'),
                                    });
                                }}
                            >
                                <FacebookSvgPc width="9px" height="16px" />
                            </FacebookShareButton>
                        </div>
                        {locale !== 'kr' && (
                            <div className="btn-wrapper twitter-icon">
                                <TwitterShareButton
                                    url={locationHref}
                                    onClick={() => {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'share',
                                            method: 'Twitter',
                                            item_id: t('presale.productname'),
                                        });
                                    }}
                                >
                                    <TwitterSvgPc width="20px" height="16px" />
                                </TwitterShareButton>
                            </div>
                        )}
                        <div
                            className="btn-wrapper email-icon"
                            onClick={() => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'share',
                                    method: 'Outlook',
                                    item_id: t('presale.productname'),
                                });
                            }}
                        >
                            <EmailShareButton url={locationHref}>
                                <OutlookSvgPc width="21px" height="16px" />
                            </EmailShareButton>
                        </div>
                        <div
                            className="btn-wrapper link-icon"
                            onClick={() => {
                                copyLink();
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'share',
                                    method: 'CopyLink',
                                    item_id: t('presale.productname'),
                                });
                            }}
                        >
                            <Tooltip
                                title={t('presale.preorder.link_copied')}
                                color={'rgba(22, 93, 225, 0.08)'}
                                placement={'bottom'}
                                visible={isLinkVisible}
                                overlayClassName={style.tooltips}
                            >
                                <LinkSvgPc width="25px" height="11px" />
                            </Tooltip>
                        </div>
                    </div>
                )}
                {locale === 'jp' && (
                    <div className="jp-tip">
                        ※キャンピングカーへの導入をご検討中のお客様には、納品やインストールなどに関してキャンピングカー専門ビルダーのRVランド様をご紹介することが可能です。
                    </div>
                )}
            </div>
            {showDetailsModal_CN && (
                <div className="detailsModal_CN">
                    <div className="mask"></div>
                    <div className="modelBox">
                        <span className="close" onClick={() => setShowDetailsModal_CN(false)}>
                            &times;
                        </span>
                        <p className="title">正浩EcoFlow</p>
                        <p className="text">扫描二维码，添加我的企业微信</p>
                        <div className="qrCodeImg">
                            <Image src="/img/common/qrCode_EF.jpg" layout="fill" className="qrCode qrCode_cn" alt="二维码" aria-label="二维码" />
                        </div>
                        <div className="closeBtn" onClick={() => setShowDetailsModal_CN(false)}>
                            关闭
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
